export const environment = {
  production: true,
  stripeKey: 'pk_live_51M8KtJSE8f6jjh8eA6kuhko9bBtZfHlt0W4SyshBpCfqVCjXZcjM6gR61egcvphytIYl7RudTmU9xEKD5Xs0N7yf00EmhZZDaD'
};
